import { IconProps } from './Icon';

export const ArrowBackIcon = ({ ...props }: IconProps) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <rect
      width="40"
      height="40"
      rx="20"
      transform="matrix(-1 0 0 1 40 0)"
      fill="#FEFEFE"
    />
    <path
      d="M22.75 28.002L14.75 20.002L22.75 12.002"
      stroke="#5E6A81"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
